import * as styles from "./SectionThreeColCardsOneFeature.module.scss";

import React, { useState } from "react";

import ArticleOrEventCard from "../../../components/SignPostCards/ArticleOrEventCard";
import StandardSignPostCard from "../../../components/SignPostCards/StandardSignPostCard";
import { Chevron, Star } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import { getBiggestCardTextCount } from "../SectionArticleOrEventCards/SectionArticleOrEventCards.utils";

import cx from "classnames";
import useWindowWidth from "../../../hooks/useWindowWidth";
export interface SectionThreeColCardsOneFeatureProps {
	items: DogsTrust.SignPostCardProps[];
	limit?: number;
	isHomePage: boolean;
}

export const Accordion: React.FC<SectionThreeColCardsOneFeatureProps> = ({
	items,
}) => {
	const [showAll, setShowAll] = useState("show");
	const canShowAll = showAll !== "show";
	return (
		<>
			<div
				className={cx({
					[styles.cards]: canShowAll,
					[styles.collapsedcards]: !canShowAll,
				})}
			>
				{items.slice(0, 8).map((card) => (
					<ArticleOrEventCard
						{...card}
						key={card.title}
						biggestSiblingTextCount={getBiggestCardTextCount(items)}
					/>
				))}
			</div>
			<div className={styles.showmorearea}>
				{!canShowAll && <div className={styles.gradient} />}
				<button
					type="button"
					className={canShowAll ? styles.showless : styles.showmore}
					onClick={() =>
						setShowAll((prev) =>
							prev === "initial" ? "show" : prev === "show" ? "hide" : "show",
						)
					}
				>
					<div className={styles.text}>
						{`Show ${canShowAll ? "less" : "more"}`}{" "}
						<Chevron
							className={styles.chevron}
							height={"16px"}
							width={"16px"}
							rotation={canShowAll ? 0 : 180}
						/>
					</div>
				</button>
				{showAll !== "initial" && (
					<span className={styles.accessibilityalert} role="alert">
						{showAll === "show"
							? "All items are now visible"
							: "Some items are now hidden"}
					</span>
				)}
			</div>
		</>
	);
};

export const SectionThreeColCardsOneFeature: React.FC<
	SectionThreeColCardsOneFeatureProps
> = ({ items, isHomePage }) => {
	items.sort((a, b) =>
		a.priority < b.priority ? -1 : a.priority < b.priority ? 1 : 0,
	);

	const windowWidth = useWindowWidth();
	const signPostItems =
		windowWidth >= 1024 ? items.slice(0, 1) : items.slice(0, 2);
	const articleItems = windowWidth >= 1024 ? items.slice(1) : items.slice(2);

	return (
		<WrappedSection
			sectionName="SectionThreeColCardsOneFeature"
			sectionColour={Colours.SANDY_FUR}
			isHomePage={isHomePage}
		>
			<div className={styles.columns}>
				<div className={styles.signpostcardsection}>
					{signPostItems.map((item) => (
						<StandardSignPostCard
							{...item}
							key={item.title}
							label={item.label}
							isSuccessStory
							buttonVariant="primary"
							promoLabel={
								<span className={styles.labeltext}>
									<Star fill="#FFFFFF" height="18px" width="18px" /> Popular
								</span>
							}
							forceSquare
						/>
					))}
				</div>
				<div className={styles.articlecardsection}>
					<Accordion items={articleItems} isHomePage={isHomePage} />
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionThreeColCardsOneFeature;
